export default __webpack_public_path__ + "static/link-item-dont-4d55622e9ff95b7b1db36822ddecd8fbe9aee65723b15f8204bd701ef1f34343.png";